export default __webpack_public_path__ + "media/images/images/flags/mt-ad168021743f049be24872628bc8305f.png";